import React from 'react';
import { AppContext } from 'components/AppContext';
import './App.scss';

function App() {
  return (
    <div className="App">
      <AppContext />
    </div>
  );
}

export { App };
